import { ApolloLink, Observable } from '@apollo/client';
import Toast from 'react-native-toast-message';

const BILLING_MESSAGE = 'Subscribe to make changes. You can still look around the app.';

const ALLOWED_MUTATIONS = new Set([
  'createCheckoutSession',
  'createStaffSeatCheckoutSession',
  'createBillingPortalSession',
  'cancelOrganizationSubscription',
  'switchOrganization',
]);

let readOnly = false;

export function setBillingReadOnly(next: boolean): void {
  readOnly = next;
}

export function isBillingReadOnly(): boolean {
  return readOnly;
}

export const billingReadOnlyLink = new ApolloLink((operation, forward) => {
  const definition = operation.query.definitions.find((item) => item.kind === 'OperationDefinition');
  const isMutation = definition?.kind === 'OperationDefinition' && definition.operation === 'mutation';
  if (!isMutation || !readOnly) {
    return forward(operation);
  }
  const name = operation.operationName || (definition.kind === 'OperationDefinition' ? definition.name?.value : '') || '';
  if (ALLOWED_MUTATIONS.has(name)) {
    return forward(operation);
  }
  Toast.show({
    type: 'error',
    text1: 'Subscribe to make changes',
    text2: 'Creating and editing stay off until this organization has an active plan.',
  });
  return new Observable((observer) => {
    observer.error(new Error(BILLING_MESSAGE));
  });
});
